<template>
  <div class="main">
    <HeaderVue class="head" />
    <Sidebar class="sidebar" />
    <Dashboard title="Editar Venda">
      <b-container fluid class="mt-4 mb-3">
        <Estoque class="estoque-pedido mb-3" />
        <b-form>
          <div class="inputs-group px-3 py-3 mb-5">
            <h3 class="mb-4"></h3>
            <b-row>
              <b-col>
                <b-form-group label="Nome do cliente" label-for="idClient">
                  <b-form-select
                    id="idClient"
                    v-model="form.idClient"
                    autocomplete="off"
                    required
                    class="transparent-select"
                    :state="validateState('idClient')"
                    aria-describedby="input-1-live-feedback"
                    :value="form.idClient"
                  >
                    <option value="" disabled selected>
                      Selecione um cliente
                    </option>
                    <option
                      v-for="opcao in clientes"
                      :value="opcao.id"
                      :key="opcao.id"
                    >
                      {{ opcao.name }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback
                    id="input-1-live-feedback"
                    style="font-weight: bold"
                  >
                    Campo obrigatório
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Data da Compra" label-for="buyDate">
                  <b-form-input
                    id="buyDate"
                    type="date"
                    v-model="form.buyDate"
                    autocomplete="off"
                    :state="validateState('buyDate')"
                    aria-describedby="input-1-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    id="input-1-live-feedback"
                    style="font-weight: bold"
                  >
                    Campo obrigatório
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Data da Entrega" label-for="deliveryDate">
                  <b-form-input
                    id="deliveryDate"
                    type="date"
                    v-model="form.deliveryDate"
                    autocomplete="off"
                    :state="validateState('deliveryDate')"
                    aria-describedby="input-1-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    id="input-1-live-feedback"
                    style="font-weight: bold"
                  >
                    Campo obrigatório
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Taxa de Entrega" label-for="deliveryTax">
                  <b-form-input
                    id="deliveryTax"
                    type="number"
                    min="0"
                    v-model="form.deliveryTax"
                    :state="validateState('deliveryTax')"
                    aria-describedby="input-1-live-feedback"
                    placeholder="R$ 0,00"
                    autocomplete="off"
                    @input="calculateTotal"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    id="input-1-live-feedback"
                    style="font-weight: bold"
                  >
                    Campo obrigatório ou incorreto
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Observações" label-for="moreDetails">
                  <b-form-textarea
                    id="moreDetails"
                    v-model="form.observation"
                    autocomplete="off"
                    placeholder="Escreva aqui..."
                    no-resize
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div class="scrollable-products inputs-group">
            <div
              v-for="(product, index) in form.products"
              :key="index"
              class="px-3 py-3"
            >
              <b-row>
                <b-col
                  >Produto
                  <h2></h2>
                  <b-form-select
                    label="Produto"
                    label-for="idProduct"
                    id="idProduct"
                    v-model="product.idProduct"
                    class="transparent-select"
                  >
                    <option value="" disabled selected>
                      Selecione um produto
                    </option>
                    <option
                      v-for="opcao in produtos"
                      :value="opcao.id"
                      :key="opcao.id"
                    >
                      {{ opcao.type }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback
                    id="input-1-live-feedback"
                    style="font-weight: bold"
                  >
                    Campo obrigatório
                  </b-form-invalid-feedback>
                </b-col>
                <b-col>
                  Tipo
                  <h2></h2>
                  <b-form-select
                    label="Tipo"
                    label-for="tipo"
                    v-model="product.tipoSelecionado"
                    class="transparent-select"
                  >
                    <option value="" disabled selected>
                      Selecione um tipo
                    </option>
                    <option
                      v-for="tipo in product.tipoOpcoes"
                      :value="tipo"
                      :key="tipo"
                    >
                      {{ tipo }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback
                    id="input-1-live-feedback"
                    style="font-weight: bold"
                  >
                    Campo obrigatório
                  </b-form-invalid-feedback>
                </b-col>
                <b-col>
                  <b-form-group label="Qtd." label-for="quantity">
                    <b-form-input
                      id="quantity"
                      type="number"
                      min="0"
                      v-model="product.quantity"
                      placeholder="Quantidade"
                      autocomplete="off"
                      @input="calculateTotal"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      id="input-1-live-feedback"
                      style="font-weight: bold"
                    >
                      Campo obrigatório ou incorreto
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Preço" label-for="price">
                    <b-form-input
                      id="price"
                      type="number"
                      min="0"
                      placeholder="R$ 0,00"
                      v-model="product.price"
                      @input="calculateTotal"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      id="input-1-live-feedback"
                      style="font-weight: bold"
                    >
                      Campo obrigatório ou incorreto
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Desconto" label-for="discount">
                    <b-form-input
                      id="discount"
                      type="number"
                      min="0"
                      max="100"
                      placeholder="%"
                      v-model="product.discount"
                      @input="calculateTotal"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      id="input-1-live-feedback"
                      style="font-weight: bold"
                    >
                      Campo obrigatório ou incorreto
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Total" label-for="total">
                    R${{ product.total ? product.total : '0,00' }}
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>
          <div
            class="inputs-group px-3 py-3 d-flex justify-content-between align-items-center"
            style="margin-top: 10px"
          >
            <span>TOTAL</span>
            <span>R${{ form.final_price ? form.final_price : '0,00' }}</span>
          </div>
          <b-alert v-model="showAlert" variant="danger" dismissible>
            {{ message }}
          </b-alert>
          <b-row class="justify-content-end px-3 py-3 mb-3">
            <b-col cols="auto">
              <b-row>
                <b-col class="col-6">
                  <b-button
                    type="button"
                    variant="danger"
                    @click="openModal(false)"
                  >
                    Cancelar
                  </b-button>
                </b-col>
                <b-col class="col-6">
                  <b-button
                    type="button"
                    variant="success"
                    @click="handleSubmit"
                  >
                    Adicionar
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </Dashboard>
    <ModalConfirmation
      :isConfirm="isConfirm"
      @responseModal="responseModal($event)"
    />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import ModalConfirmation from '../ModalConfirmation.vue';
import { Clients } from '../../services/Client';
import { Products } from '../../services/Product';
import showError from '../../utils/showError';
import Dashboard from '../Dashboard.vue';
import HeaderVue from '../Header.vue';
import Sidebar from '../Sidebar.vue';
import Estoque from './Estoque.vue';
import { EditOrder, Order } from '../../services/Order';

export default {
  components: { HeaderVue, Sidebar, Dashboard, Estoque, ModalConfirmation },
  data() {
    return {
      produtoSelecionado: null,
      isConfirm: true,
      form: {
        idClient: '',
        buyDate: '',
        deliveryDate: '',
        deliveryTax: '',
        final_price: '',
        observation: '',
        products: [
          {
            idProduct: '',
            quantity: 0,
            quantity_kg: 0,
            quantity_plate: 0,
            quantity_unity: 0,
            type: '',
            price: '',
            discount: '',
            total: '',
            totalCalculated: false,
            tipoSelecionado: '',
            tipoOpcoes: ['KG', 'BDJ', 'UNI'],
          },
        ],
      },
      saleData: {},
      produtos: {
        id: '',
        type: '',
      },
      clientes: {
        id: '',
        name: '',
      },
      state: null,
      showAlert: false,
      message: '',
    };
  },
  validations: {
    form: {
      idClient: {
        required,
      },
      buyDate: {
        required,
      },
      deliveryDate: {
        required,
      },
      deliveryTax: {
        required,
        minValue: (value) => value >= 0,
      },
      products: {
        required,
        $each: {
          idProduct: {
            required,
          },
          tipoSelecionado: {
            required,
          },
          quantity: {
            required,
            minValue: (value) => value >= 0,
          },
          price: {
            required,
            minValue: (value) => value >= 0,
          },
          discount: {
            required,
            minValue: (value) => value >= 0,
            maxValue: (value) => value <= 100,
          },
        },
      },
    },
  },
  created() {
    Products()
      .then((response) => {
        this.produtos = response.data;
      })
      .catch(showError);
    Clients()
      .then((response) => {
        this.clientes = response.data;
        this.clientes.sort((a, b) => a.name.localeCompare(b.name));
      })
      .catch(showError);
    Order(this.$route.params.saleId)
      .then((response) => {
        this.saleData = response.data;
        this.form.idClient = this.saleData.client.id;
        this.form.buyDate = this.saleData.buy_date;
        this.form.deliveryDate = this.saleData.delivery_date;
        this.form.deliveryTax = this.saleData.delivery_tax;
        this.form.final_price = this.saleData.total_price.toFixed(2);
        this.form.observation = this.saleData.observation;

        while (
          this.form.products.length < this.saleData.order_products.length
        ) {
          this.adicionarProduto();
        }

        for (let i = 0; i < this.saleData.order_products.length; i += 1) {
          const orderProduct = this.saleData.order_products[i];
          const product = this.form.products[i];

          if (orderProduct.quantity_kg > 0) {
            product.tipoSelecionado = 'KG';
            product.quantity = orderProduct.quantity_kg;
          } else if (orderProduct.quantity_plate > 0) {
            product.tipoSelecionado = 'BDJ';
            product.quantity = orderProduct.quantity_plate;
          } else if (orderProduct.quantity_unity > 0) {
            product.tipoSelecionado = 'UNI';
            product.quantity = orderProduct.quantity_unity;
          }

          product.idProduct = orderProduct.product_id;
          product.quantity_kg = orderProduct.quantity_kg;
          product.quantity_plate = orderProduct.quantity_plate;
          product.quantity_unity = orderProduct.quantity_unity;
          product.type = this.findType(orderProduct.product_id);
          product.price = orderProduct.price;
          product.discount = orderProduct.discount;
          product.total = orderProduct.total_price.toFixed(2);
          product.totalCalculated = true;
          product.tipoOpcoes = ['KG', 'BDJ', 'UNI'];
        }
      })
      .catch(showError);
  },
  methods: {
    editOrder() {
      const order = {
        client_id: this.form.idClient,
        buy_date: this.form.buyDate,
        delivery_date: this.form.deliveryDate,
        delivery_tax: this.form.deliveryTax,
        observation: this.form.observation,
        products: [],
      };

      for (let i = 0; i < this.form.products.length; i += 1) {
        const product = this.form.products[i];
        const productData = {
          id: product.idProduct,
          quantity_kg: product.tipoSelecionado === 'KG' ? product.quantity : 0,
          quantity_plate:
            product.tipoSelecionado === 'BDJ' ? product.quantity : 0,
          quantity_unity:
            product.tipoSelecionado === 'UNI' ? product.quantity : 0,
          type: this.findType(product.idProduct),
          price: product.price,
          discount: product.discount,
        };
        order.products.push(productData);
      }

      EditOrder(this.$route.params.saleId, order)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.$router.push('/vendas');
        })
        .catch(showError);
    },

    handleSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.anyError) {
        return;
      }
      this.openModal(true);
    },

    openModal(isConfirm) {
      this.isConfirm = isConfirm;
      this.$bvModal.show('modal-confirmation');
    },

    validateState(field) {
      const { $dirty, $error } = this.$v.form[field];
      return $dirty ? !$error : null;
    },

    calculateTotal() {
      this.form.products.forEach((product, index) => {
        const subtotal =
          product.price * product.quantity * (1 - product.discount / 100);

        this.form.products[index].total = subtotal;
        this.form.products[index].totalCalculated = true;
      });

      const productsTotal = this.form.products.reduce(
        (total, prod) => total + (prod.totalCalculated ? prod.total : 0),
        0
      );

      const deliveryTax = parseFloat(this.form.deliveryTax) || 0;

      const finalPrice = productsTotal + deliveryTax;

      this.form.final_price = finalPrice.toFixed(2);
    },
    findType(id) {
      let type = '';
      for (let i = 0; i < this.produtos.length; i += 1) {
        if (this.produtos[i].id === id) {
          type = this.produtos[i].type;
        }
      }
      return type;
    },
    responseModal(event) {
      if (event) {
        this.editOrder();
        return;
      }
      this.$bvModal.hide('modal-confirmation');
      this.$router.push('/vendas');
    },
    adicionarProduto() {
      this.form.products.push({
        idProduct: '',
        quantity_kg: 0,
        quantity_plate: 0,
        quantity_unity: 0,
        type: '',
        price: '',
        discount: '',
        total: '',
        tipoSelecionado: '',
        totalCalculated: false,
        tipoOpcoes: ['KG', 'BDJ', 'UNI'],
      });
    },
  },
};
</script>

<style scoped>
form,
h3 {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #121212;
}
.inputs-group {
  background: rgba(217, 217, 217, 0.54);
  border-radius: 20px;
}

input,
input:focus,
[disabled] {
  border: 1px solid black;
  background-color: transparent;
  outline: none;
  box-shadow: none;
  color: black;
}

input:focus,
#moreDetails {
  border: 1px solid black;
  background-color: transparent;
  outline: none;
  box-shadow: none;
  color: black;
}

.transparent-select {
  border: 1px solid black;
  background-color: transparent;
  outline: none;
  box-shadow: none;
  color: black;
}

input[type='color'] {
  width: 35px;
  height: 35px;
  border: none;
}

input[type='color']::-webkit-color-swatch {
  border: none;
  border-radius: 6px;
}

h3 {
  font-size: 25px;
  line-height: 30px;
}

span {
  color: #121212;
  font-family: 'Inter', sans-serif;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-right: 158px;
}

label {
  font-size: 20px;
  line-height: 24px;
}

button {
  border: none;
  padding: 8px 40px 8px 40px;
  border-radius: 24px;
  color: white;
  font-weight: 400;
  font-size: 18px;
}

button:focus {
  outline: none;
}

.scrollable-products {
  max-height: 400px; /* Defina a altura máxima desejada */
  overflow-y: auto; /* Adicione uma barra de rolagem vertical quando necessário */
}
</style>
<style scoped></style>
